import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import EditMeasurements from './EditMeasurements';
import editMeasurement from '../../../../actions/editMeasurements';
import config from '../../../../helpers/config';

const mapStateToProps = ({ estimateBuilder }, ownProps) => {
  const { entities } = estimateBuilder;
  const { itemProduct, designId } = entities.items.byId[ownProps.itemId];
  const { attributes: { isMandi } } = entities.estimates.byId[designId];
  const { attributes, skuNumber, pipToCart } = itemProduct;

  const width = Number(attributes.find(attribute => attribute.name === 'Width').value);
  const height = Number(attributes.find(attribute => attribute.name === 'Height').value);

  return {
    designId,
    width,
    height,
    productId: skuNumber,
    allowEdit: config.repId() !== null || !isMandi,
    pipToCart,
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators({ updateMeasurement: editMeasurement }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(EditMeasurements);
